export const LegacyStringMap = {
  RSAAdCustomizer_Attribute_Name: _TL_('Attribute name'),
  AdCustomizers_Editor_Syntax_Prefix_Label: _TL_('Syntax:'),
  KeywordEditor_DefaultText: _TL_('default text'),
  Picker_RSA_AdCustomizer_Label: _TL_('Ad customizer'),
  Picker_RSA_AdCustomizer_Description: _TL_('Insert custom text, number, price or percentage'),
  RSAAdCustomizer_Attribute_String: _TL_('Text'),
  RSAAdCustomizer_Attribute_Text: _TL_('Text'),
  RSAAdCustomizer_Attribute_Percent: _TL_('Percent'),
  RSAAdCustomizer_Attribute_Price: _TL_('Price'),
  RSAAdCustomizer_Attribute_Number: _TL_('Number'),
  RSAAdCustomizer_Samples: _TL_('Samples'),
  RSAAdCustomizer_Attribute_None: _TL_('None'),
  RSAAdCustomizer_Select: _TL_('Select'),
  RSAAdCustomizer_Attribute: _TL_('Attribute'),
  RSAAdCustomizer_Attribute_Seperator: _TL_(', '),
  RSAAdCustomizer_Select_Error: _TL_('Select an attribute'),
  DefaultText_Label: _TL_('Default text'),
  AdCustomizers_Editor_Set_Button: _TL_('Set'),
  Cancel: _TL_('Cancel'),
  'Click to learn more about {{item}}': _TL_('Click to learn more about {{item}}'),
};
